var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"myIframe",staticClass:"privacy-box",attrs:{"src":_vm.iframeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }